import explorePoster from "../../../images/whyus/explore.png";
import applicationPoster from "../../../images/whyus/application.png";
import projectsPoster from "../../../images/whyus/projects.png";
import certificatesPoster from "../../../images/whyus/certificates.png";

const ContentData = [
  { imgUrl: explorePoster, title: "Explore Your Interest" },
  { imgUrl: applicationPoster, title: "Application Based Learning" },
  { imgUrl: projectsPoster, title: "Industry Relevent Projects" },
  { imgUrl: certificatesPoster, title: "Professional Certificates" },
];

export default ContentData;
